import { getAction, postAction, postTag } from '@/api/manage';

const getDetailInfo = params =>
    getAction(
        process.env.VUE_APP_CMS_CUSTOMER + '/customermember/ctMmMember/queryById',
        params
    );

const getDetailList = params =>
    getAction(
        process.env.VUE_APP_CMS_CUSTOMER + '/pmom/pmOmOrder/list',
        params
    );

const exportXls = params =>
    getAction(
        process.env.VUE_APP_CMS_CUSTOMER + '/customermember/ctMmMember/exportXls',
        params
    );
export {
    getDetailInfo,
    getDetailList,
    exportXls
};
